export const PATH = {
  // 登陆
  LOGIN: '/login',
  // 版本信息
  VERSION: '/version',
  // 协议
  PROTOCOL: '/protocol',
  FRAME: '/frame',
  IMAGE_FRAME_BTN: '/imageFrameWithBtn',
  // 积分商城
  INTEGRAL: '/integral',
  // INTEGRAL_LIST: '/integral/list', // remove
  INTEGRAL_DETAILS: '/integral/details',
  INTEGRAL_V3: {
    HOME: '/integral/v3/',

  },
  // 新手学堂
  TUTORIAL: '/tutorial',
  TUTORIAL_DETAILS: '/tutorial/details',
  TUTORIAL_LIST: '/tutorial/list',
  // 转盘
  TURNTABLE: '/turntable',
  LOTTERY_LOG: '/lottery-log',
  // 红包
  RED_PACKET: '/red-packet',
  // 福利中心
  TASK: '/task',
  // 翻盘游戏
  CARD_GAME: '/card-game',
  CARD_GAME_LOG: '/card-game/log',
  // 零售商城
  MALL: '/mall',
  MALL_HOME: '/mall/home',
  MALL_PRODUCT_SEARCH: '/mall/product-search',
  MALL_PRODUCT_LIST: '/mall/product-list',
  MALL_PRODUCT_CATEGORY: '/mall/product-category',
  MALL_PRODUCT_DETAILS: '/mall/product-details',
  MALL_SHOPPING_CART: '/mall/shopping-cart',
  MALL_ORDER_CONFIRM: '/mall/order-confirm',
  MALL_ORDER_RESULT: '/mall/order-result',
  MALL_ORDER_PAY: '/mall/order-pay',
  MALL_ORDER_LIST: '/mall/order-list',
  MALL_ORDER_DETAILS: '/mall/order-details',
  // 实物交割
  DELIVERY_CONFIRM: '/delivery/confirm',
  DELIVERY_PAY: '/delivery/pay',
  DELIVERY_ADDRESS_LIST: '/delivery/address',
  ADDRESS_LIST: '/address/list',
  ADDRESS_ADD: '/address/add',
  ADDRESS_FORM: '/address/form',
  // 履约提货
  AGREEMENT: {
    INDEX: '/agreement',
    DELIVERY: '/agreement/delivery',
    DELIVERY_CONFIRM: '/agreement/delivery-confirm',
  },
  // 地址
  ADDRESS: {
    INDEX: '/address',
    // 列表
    LIST: '/address/list',
    // 添加
    ADD: '/address/add',
    // 修改
    FORM: '/address/form'
  },
  MESSAGE: '/message',
  // 抽奖合集
  LOTTERY: {
    INDEX: '/lottery',
    EGG: '/lottery/egg',
    EGG_LOG: '/lottery/egg-log',
    PIG: '/lottery/pig',
    PIG_LOG: '/lottery/pig-log',
    LUCKY_BAG: '/lottery/lucky-bag',
    LUCKY_BAG_LOG: '/lottery/lucky-bag-log'
  },
  // 活动
  EVENTS: {
    INDEX: '/events',
    FEE_OFF: '/events/fee-off',
    INTEGRAL_GO: '/events/integral-go',
    NEW_USER_EVENT: '/events/new-user-event',
    HAPPY_FRIDAY: '/events/happy-friday',
    HAIOU_USER_WELFARE: '/events/haiou-user-welfare',
    XINIU_USER_TRANS: '/events/xiniu_user_trans', //  犀牛用户转犀贝公告
    NEW_YEAR_EVENT: '/events/new-year-event',
    INTEGRAL_EVENT_2: '/events/integral-event-2',
    INTEGRAL_EVENT_3: '/events/integral-event-3',
    INTEGRAL_EVENT_4: '/events/integral-event-4',
  },
  // test
  TEST: '/test'
}
